import { supabase } from './supabase';

const inflight = new Set<string>();

export async function recordResourceView(resourceId: string): Promise<void> {
  const id = (resourceId || '').trim();
  if (!id) return;

  if (inflight.has(id)) return;
  inflight.add(id);

  try {
    const { error } = await supabase.rpc('increment_resource_view', { p_resource_id: id });
    if (error) throw error;
  } catch (error) {
    if (import.meta.env.DEV && import.meta.env.MODE !== 'test') {
      console.warn('recordResourceView failed:', error);
    }
  } finally {
    inflight.delete(id);
  }
}
